<template>
  <div class="dashboard">
    <!-- 欢迎区 -->
    <div class="welcome">
      <div class="welcome-left">
        <div class="welcome-title">{{ greeting }}，管理员 <span class="adm-name">ANALIAFLORA</span></div>
        <div class="welcome-sub">欢迎使用鲜花商城后台管理系统</div>
      </div>
      <div class="welcome-right">
        <div class="welcome-time">{{ nowDate }}</div>
        <div class="welcome-week">{{ nowWeek }} · {{ nowTime }}</div>
      </div>
    </div>

    <!-- 统计卡片区 -->
    <div class="stat-title">数据概览</div>
    <div class="stat-grid">
      <div class="stat-card stat-1 stat-clickable" @click="goStatCard('user')">
        <i class="stat-icon el-icon-user"></i>
        <div class="stat-info">
          <div class="stat-num">
            <animate-number from="0" :to="fw.userCount" :key="'u' + fw.userCount" duration="500"></animate-number>
          </div>
          <div class="stat-label">总用户量</div>
        </div>
        <i class="stat-arrow el-icon-arrow-right"></i>
      </div>
      <div class="stat-card stat-2 stat-clickable" @click="goStatCard('order', 0)">
        <i class="stat-icon el-icon-box"></i>
        <div class="stat-info">
          <div class="stat-num">
            <animate-number from="0" :to="fw.orderCount" :key="'o' + fw.orderCount" duration="500"></animate-number>
          </div>
          <div class="stat-label">总订单量</div>
        </div>
        <i class="stat-arrow el-icon-arrow-right"></i>
      </div>
      <div class="stat-card stat-3 stat-clickable" @click="goStatCard('order', 2)">
        <i class="stat-icon el-icon-truck"></i>
        <div class="stat-info">
          <div class="stat-num">
            <animate-number from="0" :to="fw.fhCount" :key="'f' + fw.fhCount" duration="500"></animate-number>
          </div>
          <div class="stat-label">待发货</div>
        </div>
        <i class="stat-arrow el-icon-arrow-right"></i>
      </div>
      <div class="stat-card stat-4 stat-clickable" @click="goStatCard('order', 8)">
        <i class="stat-icon el-icon-key"></i>
        <div class="stat-info">
          <div class="stat-num">
            <animate-number from="0" :to="extra.pickUpCount" :key="'p' + extra.pickUpCount" duration="500"></animate-number>
          </div>
          <div class="stat-label">待提货</div>
        </div>
        <i class="stat-arrow el-icon-arrow-right"></i>
      </div>
      <div class="stat-card stat-5 stat-clickable" @click="goStatCard('order', 6)">
        <i class="stat-icon el-icon-circle-check"></i>
        <div class="stat-info">
          <div class="stat-num">
            <animate-number from="0" :to="fw.ywCount" :key="'y' + fw.ywCount" duration="500"></animate-number>
          </div>
          <div class="stat-label">已完成</div>
        </div>
        <i class="stat-arrow el-icon-arrow-right"></i>
      </div>
      <div class="stat-card stat-6 stat-clickable" @click="goStatCard('good')">
        <i class="stat-icon el-icon-shopping-bag-2"></i>
        <div class="stat-info">
          <div class="stat-num">
            <animate-number from="0" :to="extra.goodCount" :key="'g' + extra.goodCount" duration="500"></animate-number>
          </div>
          <div class="stat-label">商品总数</div>
        </div>
        <i class="stat-arrow el-icon-arrow-right"></i>
      </div>
      <div class="stat-card stat-7 stat-clickable" @click="goStatCard('classify')">
        <i class="stat-icon el-icon-menu"></i>
        <div class="stat-info">
          <div class="stat-num">
            <animate-number from="0" :to="extra.classifyCount" :key="'c' + extra.classifyCount" duration="500"></animate-number>
          </div>
          <div class="stat-label">商品分类</div>
        </div>
        <i class="stat-arrow el-icon-arrow-right"></i>
      </div>
      <div class="stat-card stat-8 stat-clickable" @click="goStatCard('show')">
        <i class="stat-icon el-icon-picture"></i>
        <div class="stat-info">
          <div class="stat-num">
            <animate-number from="0" :to="extra.showCount" :key="'s' + extra.showCount" duration="500"></animate-number>
          </div>
          <div class="stat-label">买家秀数</div>
        </div>
        <i class="stat-arrow el-icon-arrow-right"></i>
      </div>
      <div class="stat-card stat-9 stat-clickable" @click="goStatCard('order', 4)">
        <i class="stat-icon el-icon-warning-outline"></i>
        <div class="stat-info">
          <div class="stat-num">
            <animate-number from="0" :to="extra.refundCount" :key="'r' + extra.refundCount" duration="500"></animate-number>
          </div>
          <div class="stat-label">申请退款</div>
        </div>
        <i class="stat-arrow el-icon-arrow-right"></i>
      </div>
    </div>

    <!-- 快捷导航 -->
    <div class="quick-nav-title">快捷导航</div>
    <div class="quick-nav-grid">
      <div
        class="quick-nav-item"
        v-for="(nav, idx) in quickNavs"
        :key="nav.path"
        :style="{ animationDelay: idx * 60 + 'ms' }"
        @click="goQuickNav(nav)"
      >
        <div class="quick-nav-icon" :style="{ background: nav.color }">
          <i :class="nav.icon"></i>
        </div>
        <span class="quick-nav-label">{{ nav.label }}</span>
      </div>
    </div>

    <!-- 最近订单 -->
    <div class="recent-wrap">
      <div class="panel-header">
        <span class="panel-title">最近订单</span>
        <el-button type="text" @click="goOrder">查看全部</el-button>
      </div>
      <!-- PC/平板端：表格 -->
      <el-table :data="recentOrders" border size="small" v-loading="loadingOrder" style="width: 100%;" class="table-then-card">
        <el-table-column prop="orderTime" label="下单时间" width="160" align="center"></el-table-column>
        <el-table-column prop="orderNum" label="订单编号" min-width="180"></el-table-column>
        <el-table-column prop="nickname" label="下单用户" width="120" align="center"></el-table-column>
        <el-table-column prop="uphone" label="联系方式" width="140" align="center"></el-table-column>
        <el-table-column label="订单状态" width="110" align="center">
          <template slot-scope="scope">
            <el-tag :type="statusTagType(scope.row.status)" effect="dark" size="mini">
              {{ statusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="money" label="付款金额(元)" width="120" align="center"></el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.status == 2">
              <el-button type="text" icon="el-icon-position" @click="handleOrderSipping(scope.row)">确认发货</el-button>
            </template>
            <template v-if="scope.row.status == 8">
              <el-button type="text" icon="el-icon-circle-check" style="color:#e6a23c" @click="handleVerifyPickUp(scope.row)">核销提货</el-button>
              <el-button type="text" icon="el-icon-success" style="color:green" @click="handleOrderStatus(scope.row)">确认完成</el-button>
            </template>
            <template v-if="scope.row.status == 4">
              <el-button type="text" icon="el-icon-success" style="color:green" @click="handleOrderStatus(scope.row, 0)">同意</el-button>
              <el-button type="text" icon="el-icon-close" style="color:#ff2000" @click="handleOrderStatus(scope.row, 1)">拒绝</el-button>
            </template>
            <el-button type="text" icon="el-icon-view" @click="goOrder">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 手机端：卡片列表 -->
      <div class="mobile-card-list" v-loading="loadingOrder">
        <div v-for="row in recentOrders" :key="row.oid" class="mc-card">
          <div class="mc-header">
            <div class="mc-header-left">
              <el-tag effect="dark" :type="statusTagType(row.status)" size="small">{{ statusText(row.status) }}</el-tag>
              <el-tag v-if="row.psMode == 1" size="small">自提</el-tag>
              <el-tag v-else-if="row.psMode == 2" type="success" size="small">配送</el-tag>
            </div>
            <span class="mc-subtitle">{{ row.orderTime }}</span>
          </div>
          <div class="mc-row">
            <span class="mc-label">订单编号</span>
            <span class="mc-value">{{ row.orderNum }}</span>
          </div>
          <div class="mc-grid-2">
            <div class="mc-row">
              <span class="mc-label">付款金额</span>
              <span class="mc-value mc-value-danger">¥{{ row.money }}</span>
            </div>
            <div class="mc-row">
              <span class="mc-label">下单用户</span>
              <span class="mc-value">{{ row.nickname || '-' }}</span>
            </div>
            <div class="mc-row">
              <span class="mc-label">联系方式</span>
              <span class="mc-value">{{ row.uphone || '-' }}</span>
            </div>
          </div>
          <div class="mc-actions">
            <el-button v-if="row.status == 2" type="primary" size="small" icon="el-icon-position" @click="handleOrderSipping(row)">确认发货</el-button>
            <el-button v-if="row.status == 8" type="warning" size="small" icon="el-icon-circle-check" @click="handleVerifyPickUp(row)">核销提货</el-button>
            <el-button v-if="row.status == 8" type="success" size="small" icon="el-icon-success" @click="handleOrderStatus(row)">确认完成</el-button>
            <el-button v-if="row.status == 4" type="success" size="small" icon="el-icon-success" @click="handleOrderStatus(row, 0)">同意</el-button>
            <el-button v-if="row.status == 4" type="danger" size="small" icon="el-icon-close" @click="handleOrderStatus(row, 1)">拒绝</el-button>
            <el-button size="small" icon="el-icon-view" @click="goOrder">详情</el-button>
          </div>
        </div>
        <div v-if="!loadingOrder && recentOrders.length === 0" style="text-align:center;color:#909399;padding:20px 0;">暂无数据</div>
      </div>
    </div>

    <!-- 发货弹窗 -->
    <el-dialog title="发货信息" :visible.sync="fhFlag" :width="dialogWidthSmall">
      <el-form label-position="left" :rules="fhRules" ref="fhObj" label-width="100px" :model="fhObj" status-icon>
        <el-form-item label="发货单号" prop="trackingNumber">
          <el-input placeholder="请输入发货单号" prefix-icon="el-icon-edit" v-model="fhObj.trackingNumber"></el-input>
        </el-form-item>
        <el-form-item label="配送公司" prop="logisticsCompany">
          <el-input placeholder="请输入配送公司" prefix-icon="el-icon-edit" v-model="fhObj.logisticsCompany"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="subFh('fhObj')">确 定</el-button>
        <el-button @click="fhFlag = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 核销弹窗 -->
    <el-dialog title="核销提货" :visible.sync="verifyFlag" :width="dialogWidthSmall" @close="verifyPickCode=''">
      <el-form label-position="left" :rules="verifyRules" ref="verifyForm" label-width="100px" :model="{pickCode: verifyPickCode}" status-icon>
        <el-form-item label="提货码" prop="pickCode">
          <el-input placeholder="请输入提货码" prefix-icon="el-icon-key" v-model="verifyPickCode"></el-input>
        </el-form-item>
        <div v-if="verifyOrderInfo" style="background:#f5f7fa;padding:10px;border-radius:4px;margin-bottom:16px;">
          <div style="font-size:13px;color:#606266;margin-bottom:6px;">订单信息确认</div>
          <div>订单号：{{ verifyOrderInfo.orderNum }}</div>
          <div>下单用户：{{ verifyOrderInfo.nickname || '-' }}</div>
          <div>付款金额：¥{{ verifyOrderInfo.money }}</div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="subVerify" :loading="verifyLoading">确认核销</el-button>
        <el-button @click="verifyFlag = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { countData, queryGoods, queryClassifys, queryShows, queryOrders, putOrdersShipment, putOrdersRefund, putOrdersNoRefund, postOrderAccomplish, postOrderVerify } from '@/api';

const STATUS_MAP = {
  1: { text: '待付款', type: 'warning' },
  2: { text: '待发货', type: '' },
  3: { text: '待收货', type: '' },
  4: { text: '申请退款', type: 'danger' },
  5: { text: '已退款', type: 'danger' },
  6: { text: '已完成', type: 'success' },
  7: { text: '已取消', type: 'info' },
  8: { text: '待提货', type: '' },
};

export default {
  name: "Dashboard",
  data() {
    return {
      fw: {
        userCount: 0,
        orderCount: 0,
        fhCount: 0,
        ywCount: 0,
      },
      extra: {
        goodCount: 0,
        classifyCount: 0,
        showCount: 0,
        refundCount: 0,
        pickUpCount: 0,
      },
      recentOrders: [],
      loadingOrder: false,
      now: new Date(),
      timer: null,
      // WebSocket 事件自动刷新防抖
      eventRefreshTimer: null,
      // 快捷导航
      quickNavs: [
        { label: '订单管理', icon: 'el-icon-box', path: '/orderAdm', menuKey: '4', color: '#c85a6a' },
        { label: '商品管理', icon: 'el-icon-shopping-bag-2', path: '/goodAdm', menuKey: '3', color: '#9254de' },
        { label: '分类管理', icon: 'el-icon-s-grid', path: '/classifyAdm', menuKey: '6', color: '#13c2c2' },
        { label: '买家秀', icon: 'el-icon-position', path: '/showsAdm', menuKey: '5', color: '#f5a623' },
        { label: '用户管理', icon: 'el-icon-user', path: '/userAdm', menuKey: '2', color: '#409eff' },
        { label: '系统设置', icon: 'el-icon-setting', path: '/setting', menuKey: '7', color: '#909399' },
      ],
      // 发货弹窗
      fhFlag: false,
      fhObj: { oid: '', trackingNumber: '', logisticsCompany: '' },
      fhRules: {
        trackingNumber: [{ required: true, message: '发货单号不能为空', trigger: 'blur' }],
        logisticsCompany: [{ required: true, message: '配送公司不能为空', trigger: 'blur' }],
      },
      // 核销弹窗
      verifyFlag: false,
      verifyPickCode: '',
      verifyLoading: false,
      verifyOrderInfo: null,
      verifyRules: {
        pickCode: [{ required: true, message: '提货码不能为空', trigger: 'blur' }],
      },
    };
  },
  computed: {
    greeting() {
      const h = this.now.getHours();
      if (h < 6) return '凌晨好';
      if (h < 9) return '早上好';
      if (h < 12) return '上午好';
      if (h < 14) return '中午好';
      if (h < 18) return '下午好';
      return '晚上好';
    },
    nowDate() {
      const d = this.now;
      return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`;
    },
    nowWeek() {
      const names = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      return names[this.now.getDay()];
    },
    nowTime() {
      const d = this.now;
      const p = (n) => (n < 10 ? '0' + n : '' + n);
      return `${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
    },
  },
  watch: {
    // 监听 WebSocket 订单事件，实时刷新首页数据
    "$store.state.lastOrderEvent"(evt) {
      if (!evt) return;
      if (this.eventRefreshTimer) clearTimeout(this.eventRefreshTimer);
      this.eventRefreshTimer = setTimeout(() => {
        this.loadCount();
        this.loadExtra();
        this.loadRecentOrders();
      }, 800);
    }
  },
  methods: {
    statusText(s) {
      return (STATUS_MAP[s] && STATUS_MAP[s].text) || '未知';
    },
    statusTagType(s) {
      return (STATUS_MAP[s] && STATUS_MAP[s].type) || '';
    },
    goQuickNav(nav) {
      sessionStorage.setItem('n', nav.menuKey);
      this.$router.push(nav.path).catch(() => {});
    },
    goOrder() {
      sessionStorage.setItem('n', '4');
      this.$router.push('/orderAdm').catch(() => {});
    },
    // 数据概览卡片跳转
    goStatCard(type, status) {
      const routeMap = {
        user:     { path: '/userAdm',     menuKey: '2' },
        good:     { path: '/goodAdm',     menuKey: '3' },
        classify: { path: '/classifyAdm', menuKey: '6' },
        show:     { path: '/showsAdm',    menuKey: '5' },
        order:    { path: '/orderAdm',    menuKey: '4' },
      };
      const target = routeMap[type];
      if (!target) return;
      sessionStorage.setItem('n', target.menuKey);
      const query = (type === 'order' && status !== undefined) ? { status } : {};
      this.$router.push({ path: target.path, query }).catch(() => {});
    },
    dialogWidthSmall() {
      return window.innerWidth < 768 ? '95%' : '500px';
    },
    // 发货
    handleOrderSipping(row) {
      this.fhObj.oid = row.oid;
      this.fhFlag = true;
    },
    subFh(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        this.$confirm('是否确定该信息发货?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          putOrdersShipment(this.fhObj).then((res) => {
            this.fhFlag = false;
            if (res.code != 0) {
              this.$message.warning(res.msg);
              return false;
            }
            this.loadRecentOrders();
            this.loadCount();
            this.fhObj = { oid: '', trackingNumber: '', logisticsCompany: '' };
            this.$message.success(res.msg);
          });
        });
      });
    },
    // 核销提货
    handleVerifyPickUp(row) {
      this.verifyPickCode = (row && row.pickCode) || '';
      this.verifyOrderInfo = row;
      this.verifyFlag = true;
    },
    subVerify() {
      this.$refs.verifyForm.validate((valid) => {
        if (!valid) return false;
        this.$confirm('是否确认核销该提货码?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          this.verifyLoading = true;
          try {
            const res = await postOrderVerify({ pickCode: this.verifyPickCode.trim() });
            if (res.code != 0) {
              this.$message.error(res.msg || '核销失败');
              return;
            }
            this.$message.success(res.msg || '核销成功');
            this.verifyFlag = false;
            this.verifyPickCode = '';
            this.verifyOrderInfo = null;
            this.loadRecentOrders();
            this.loadCount();
          } catch (e) {
            this.$message.error('核销失败，请重试');
          } finally {
            this.verifyLoading = false;
          }
        });
      });
    },
    // 操作订单状态（同意/拒绝退款、确认完成）
    handleOrderStatus(row, n) {
      let { oid, uid, status } = row;
      let mm = '';
      if (status == 4) {
        mm = n == 0 ? '同意退款' : '拒绝退款';
      } else if (status == 8) {
        mm = '该用户已提货完成';
      }
      this.$confirm(`是否确定${mm}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        let res = null;
        switch (status) {
          case 4:
            if (n == 0) {
              const loading = this.$loading({ lock: true, text: '退款中...', background: 'rgba(255, 255, 255, 0.6)' });
              res = await putOrdersRefund({ oid });
              loading.close();
            } else {
              res = await putOrdersNoRefund({ oid });
            }
            if (res.code != 0) {
              this.$message.error(res.msg);
              return false;
            }
            this.$message.success(res.msg);
            break;
          case 8:
            res = await postOrderAccomplish({ oid, uid });
            if (res.code != 0) {
              this.$message.error('确认失败,请联系开发者！');
              return false;
            }
            this.$message.success('该订单已确定成功！');
            break;
          default:
            break;
        }
        this.loadRecentOrders();
        this.loadCount();
      });
    },
    loadCount() {
      countData().then(
        (res) => {
          if (res && res.data) this.fw = res.data;
        },
        () => {
          this.$message({ showClose: true, message: '服务器错误', type: 'error' });
        }
      );
    },
    loadExtra() {
      // 商品总数
      queryGoods({ pageNum: 1, pageSize: 1 }).then((res) => {
        if (res) this.extra.goodCount = res.total || 0;
      }).catch(() => {});
      // 分类数量
      queryClassifys().then((res) => {
        if (res && Array.isArray(res.data)) {
          this.extra.classifyCount = res.data.length;
        } else if (res && Array.isArray(res.list)) {
          this.extra.classifyCount = res.list.length;
        }
      }).catch(() => {});
      // 买家秀总数
      queryShows({ pageNum: 1, pageSize: 1 }).then((res) => {
        if (res) this.extra.showCount = res.total || 0;
      }).catch(() => {});
      // 申请退款订单
      queryOrders({ pageNum: 1, pageSize: 1, status: 4 }).then((res) => {
        if (res) this.extra.refundCount = res.total || 0;
      }).catch(() => {});
      // 待提货订单
      queryOrders({ pageNum: 1, pageSize: 1, status: 8 }).then((res) => {
        if (res) this.extra.pickUpCount = res.total || 0;
      }).catch(() => {});
    },
    loadRecentOrders() {
      this.loadingOrder = true;
      queryOrders({ pageNum: 1, pageSize: 3, status: '' }).then((res) => {
        if (res && res.list) this.recentOrders = res.list;
      }).catch(() => {}).finally(() => {
        this.loadingOrder = false;
      });
    },
  },
  created() {
    this.loadCount();
    this.loadExtra();
    this.loadRecentOrders();
    this.timer = setInterval(() => {
      this.now = new Date();
    }, 1000);
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
    if (this.eventRefreshTimer) clearTimeout(this.eventRefreshTimer);
  },
};
</script>

<style scoped>
.dashboard {
  padding: 20px;
  box-sizing: border-box;
}

.welcome {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px;
  color: #fff;
  border-radius: 10px;
  background: linear-gradient(135deg, #409eff 0%, #36cfc9 100%);
  box-shadow: 0 2px 12px rgba(64, 158, 255, 0.2);
}

.welcome-title {
  font-size: 22px;
  font-weight: bold;
}

.adm-name {
  color: #fff58a;
  margin-left: 6px;
}

.welcome-sub {
  margin-top: 6px;
  font-size: 14px;
  opacity: 0.9;
}

.welcome-right {
  text-align: right;
}

.welcome-time {
  font-size: 18px;
  font-weight: bold;
}

.welcome-week {
  font-size: 13px;
  margin-top: 6px;
  opacity: 0.9;
}

.stat-title {
  margin: 22px 0 12px;
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  border-left: 3px solid #409eff;
  padding-left: 8px;
}

.stat-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.stat-card {
  display: flex;
  align-items: center;
  padding: 18px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  transition: all 0.3s;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.stat-clickable {
  cursor: pointer;
  position: relative;
}

.stat-clickable:active {
  transform: scale(0.97);
  transition-duration: 0.1s;
}

.stat-arrow {
  position: absolute;
  right: 12px;
  bottom: 10px;
  font-size: 12px;
  color: #c0c4cc;
  opacity: 0;
  transition: opacity 0.2s, transform 0.2s;
}

.stat-clickable:hover .stat-arrow {
  opacity: 1;
  transform: translateX(3px);
}

.stat-icon {
  width: 58px;
  height: 58px;
  line-height: 58px;
  text-align: center;
  font-size: 30px;
  color: #fff;
  border-radius: 8px;
  margin-right: 14px;
  flex-shrink: 0;
}

.stat-info {
  flex: 1;
}

.stat-num {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
}

.stat-label {
  margin-top: 4px;
  font-size: 13px;
  color: #909399;
}

.stat-1 .stat-icon { background: #409eff; }
.stat-2 .stat-icon { background: #c85a6a; }
.stat-3 .stat-icon { background: #e6a23c; }
.stat-4 .stat-icon { background: #e6a23c; }
.stat-5 .stat-icon { background: #67c23a; }
.stat-6 .stat-icon { background: #9254de; }
.stat-7 .stat-icon { background: #13c2c2; }
.stat-8 .stat-icon { background: #f5a623; }
.stat-9 .stat-icon { background: #f56c6c; }

/* ====== 快捷导航 ====== */
.quick-nav-title {
  margin: 22px 0 12px;
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  border-left: 3px solid #409eff;
  padding-left: 8px;
}

.quick-nav-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px;
}

.quick-nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 18px 8px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  animation: quickNavIn 0.4s ease both;
}

.quick-nav-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
  border-color: transparent;
}

.quick-nav-item:active {
  transform: scale(0.96);
  transition-duration: 0.1s;
}

@keyframes quickNavIn {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.quick-nav-icon {
  width: 48px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  font-size: 24px;
  color: #fff;
  border-radius: 12px;
  margin-bottom: 10px;
  transition: transform 0.3s ease;
}

.quick-nav-item:hover .quick-nav-icon {
  transform: scale(1.1);
}

.quick-nav-label {
  font-size: 13px;
  color: #606266;
  white-space: nowrap;
}

.recent-wrap {
  margin-top: 22px;
  padding: 18px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.panel-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  border-left: 3px solid #409eff;
  padding-left: 8px;
}

@media (max-width: 1200px) {
  .stat-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .quick-nav-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* 平板端适配 */
@media (min-width: 768px) and (max-width: 1024px) {
  .dashboard {
    padding: 14px;
  }
  .welcome {
    padding: 18px 20px;
  }
  .welcome-title {
    font-size: 18px;
  }
  .stat-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  .stat-card {
    padding: 14px;
  }
  .stat-icon {
    width: 48px;
    height: 48px;
    line-height: 48px;
    font-size: 24px;
  }
  .stat-num {
    font-size: 20px;
  }
  .quick-nav-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }
  .quick-nav-item {
    padding: 14px 6px;
  }
  .quick-nav-icon {
    width: 42px;
    height: 42px;
    line-height: 42px;
    font-size: 20px;
    border-radius: 10px;
    margin-bottom: 8px;
  }
  .quick-nav-label {
    font-size: 12px;
  }
  .recent-wrap {
    padding: 14px;
  }
}

/* 手机端适配 */
@media (max-width: 767px) {
  .dashboard {
    padding: 10px;
  }
  .welcome {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px 18px;
    gap: 10px;
  }
  .welcome-right {
    text-align: left;
  }
  .welcome-title {
    font-size: 17px;
  }
  .welcome-time {
    font-size: 15px;
  }
  .stat-title {
    margin: 14px 0 8px;
    font-size: 14px;
  }
  .stat-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
  .stat-card {
    padding: 12px;
    border-radius: 6px;
  }
  .stat-icon {
    width: 42px;
    height: 42px;
    line-height: 42px;
    font-size: 20px;
    margin-right: 10px;
  }
  .stat-num {
    font-size: 18px;
  }
  .stat-label {
    font-size: 12px;
  }
  .quick-nav-title {
    margin: 14px 0 8px;
    font-size: 14px;
  }
  .quick-nav-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }
  .quick-nav-item {
    padding: 14px 4px;
    border-radius: 10px;
    -webkit-tap-highlight-color: transparent;
  }
  .quick-nav-icon {
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    border-radius: 10px;
    margin-bottom: 8px;
  }
  .quick-nav-label {
    font-size: 11px;
  }
  .recent-wrap {
    margin-top: 14px;
    padding: 12px;
    border-radius: 6px;
  }
  .panel-title {
    font-size: 14px;
  }
}
</style>
